import AdminFeature from '../http/adminFeature'

export default class AdminFeatureService {
  static async isFeatureEnabled (clientId, feature) {
    const response = await AdminFeature.isFeatureEnabled(clientId, feature)
    return response.data
  }
}
